// extracted by mini-css-extract-plugin
module.exports = {"community-map":"CommunityMap_community-map__tlkgt","marker":"CommunityMap_marker__1remj","text":"CommunityMap_text__SRjCG"};